function initStableNavbarDropdowns() {
    const dropdowns = Array.from(document.querySelectorAll('.ui-navbar-item.has-dropdown'));

    dropdowns.forEach((dropdown) => {
        const trigger = dropdown.querySelector('.ui-navbar-link');
        const panel = dropdown.querySelector('.ui-navbar-dropdown');

        if (!trigger || !panel) {
            return;
        }

        let closeTimer = null;

        const open = () => {
            if (closeTimer) {
                window.clearTimeout(closeTimer);
                closeTimer = null;
            }
            dropdown.classList.add('is-active');
        };

        const close = () => {
            if (closeTimer) {
                window.clearTimeout(closeTimer);
            }
            closeTimer = window.setTimeout(() => {
                dropdown.classList.remove('is-active');
            }, 180);
        };

        const toggle = (event) => {
            event.preventDefault();
            if (dropdown.classList.contains('is-active')) {
                dropdown.classList.remove('is-active');
            } else {
                open();
            }
        };

        dropdown.addEventListener('mouseenter', open);
        dropdown.addEventListener('mouseleave', close);
        dropdown.addEventListener('focusin', open);
        dropdown.addEventListener('focusout', () => {
            window.setTimeout(() => {
                if (!dropdown.contains(document.activeElement)) {
                    close();
                }
            }, 0);
        });

        trigger.addEventListener('click', toggle);
    });

    document.addEventListener('click', (event) => {
        dropdowns.forEach((dropdown) => {
            if (!dropdown.contains(event.target)) {
                dropdown.classList.remove('is-active');
            }
        });
    });
}

document.addEventListener('DOMContentLoaded', initStableNavbarDropdowns);
